/** Tripiigo brand purple — from official logo */
export const BRAND_PURPLE = '#6221d6';
export const BRAND_PURPLE_DARK = '#4c1aa8';
export const BRAND_PURPLE_LIGHT = '#8b5cf6';
export const BRAND_BLACK = '#0a0a0a';

/** Platform brand — single source of truth for UI copy */
export const APP_NAME = 'Tripiigo';
export const APP_TAGLINE = 'Smart Transport Management Platform';
export const APP_FULL_NAME = 'Tripiigo TMS';
export const PLATFORM_DOMAIN = 'tripiigo.com';
export const PLATFORM_URL = `https://${PLATFORM_DOMAIN}`;

export const LOGO_PATH = '/tripiigo-logo.png';

/** Development partner credit (shown in footers system-wide) */
export const DEV_PARTNER_NAME = 'SelfStart Tech';
export const DEV_PARTNER_URL = 'https://www.selfstarttech.com/';

export const platformTenantUrl = (subdomain: string) =>
  subdomain ? `https://${subdomain}.${PLATFORM_DOMAIN}` : '';

export const platformTenantHost = (subdomain: string) =>
  subdomain ? `${subdomain}.${PLATFORM_DOMAIN}` : '';
